<template>
    <div class="childtrackingsystem-results">
        <div
            v-if="!isAnalyse && !isChildForm"
            class="row row-cols-auto align-items-center bg-white py-3"
        >
            <label class="col col-form-label fw-bold">Kinderen</label>
            <div class="col-3">
                <select
                    class="form-select form-select-sm"
                    @change="childSelect($event)"
                >
                    <option value="0">Alle</option>
                    <option
                        v-for="child in childrenCTS"
                        :key="child.id"
                        :value="child.id"
                    >{{ child.name }}
                    </option>
                </select>
            </div>
            <label class="col col-form-label fw-bold">Observatielijsten</label>
            <div class="col-3">
                <select
                    class="form-select form-select-sm"
                    @change="listSelect($event)"
                >
                    <option value="0">Alle</option>
                    <option
                        v-for="list in lists"
                        :key="list.id"
                        :value="list.id"
                    >{{ list.titel }}
                    </option>
                </select>
            </div>
            <div class="col ms-auto">
                <button
                    class="btn btn-outline-danger"
                    @click="getResults(false)"
                    v-if="showActive"
                >Ga naar archief
                </button>
                <button
                    class="btn btn-outline-success"
                    @click="getResults(true)"
                    v-if="!showActive"
                >Verlaat archief
                </button>
            </div>
        </div>

        <div
            v-if="!isAnalyse && !isChildForm"
            class="row bg-white"
        >
            <div
                v-if="isAllResults"
                class="col-md-12"
            >
                <table class="table">
                    <thead>
                        <tr>
                            <th>Observatielijst</th>
                            <th class="text-end pe-1">
                                <span
                                    data-bs-toggle="modal"
                                    data-bs-target="#infoModal"
                                >
                                    <icon name="info"></icon>
                                </span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(result,key) in results"
                            :key="key"
                        >
                            <td :style="'color:' + result.alert">
                                <b>{{ result.listTitle }}</b> van kind <b>{{ result.childName }}</b>
                                ({{ result.childAge }}) opgeslagen op {{ result.date }}
                            </td>
                            <td
                                class="text-end pe-1"
                                style="width:180px;"
                            >
                                <span
                                    style="margin-top: 5px; margin-right: 15px;color:#666;"
                                    title="Bekijk"
                                    @click="openAnalyse(result.id)"
                                >
                                    <icon name="look-into"></icon>
                                </span>
                                <span
                                    style="margin-top: 5px; margin-right: 15px;"
                                    title="Herinnering"
                                    data-bs-toggle="modal"
                                    :data-bs-target="'#' + 'saveasModal' + result.id"
                                >
                                    <icon name="reminder"></icon>
                                </span>
                                <span
                                    style="margin-top: 5px; margin-right: 15px;color:#666;"
                                    title="Maak formulier aan"
                                    @click="openChildForm(result.id, result.idChildForm)"
                                >
                                    <icon name="file-contract"></icon>
                                </span>
                            </td>

                            <div
                                class="modal modal-lg fade"
                                :id="'saveasModal' + result.id"
                                tabindex="-1"
                                aria-hidden="true"
                            >
                                <div class="modal-dialog">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <button
                                                type="button"
                                                class="btn-close"
                                                data-bs-dismiss="modal"
                                                aria-label="Close"
                                            ></button>
                                        </div>
                                        <div class="modal-body">
                                            <div class="row row-cols-auto d-flex align-items-center py-2 border-top border-bottom">
                                                <label class="col col-form-label fw-bold">Periode</label>
                                                <div class="col">
                                                    <select
                                                        class="form-select form-select-sm"
                                                        id="triggerPeriod"
                                                        name="triggerPeriod"
                                                        @change="changeTrigger($event)"
                                                    >
                                                        <option
                                                            value="0"
                                                            selected
                                                        >Kies een periode
                                                        </option>
                                                        <option value="1">Over 1 week</option>
                                                        <option value="2">Over 2 weken</option>
                                                        <option value="3">Over 3 weken</option>
                                                        <option value="4">Over 4 weken</option>
                                                        <option value="8">Over 2 maanden</option>
                                                        <option value="12">Over 3 maanden</option>
                                                        <option value="16">Over 4 maanden</option>
                                                        <option value="20">Over 5 maanden</option>
                                                        <option value="24">Over 6 maanden</option>
                                                    </select>
                                                </div>
                                                <div class="col">OF</div>
                                                <label class="col col-form-label fw-bold">Datum</label>
                                                <div class="col">
                                                    <input
                                                        id="triggerDate"
                                                        type="date"
                                                        name="triggerDate"
                                                        size="12"
                                                        @input="changeTrigger($event);"
                                                    >
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12">
                                                    <label class="form-label fw-bold">Omschrijving</label>
                                                    <textarea
                                                        class="form-control"
                                                        id="triggerDescription"
                                                        name="triggerDescription"
                                                        @input="changeTrigger($event)"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="modal-footer">
                                            <button
                                                class="btn btn-secondary"
                                                name="action"
                                                value="saveTrigger"
                                                @click="saveTrigger(result.id)"
                                            >
                                                Opslaan
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="isAnalyse">
            <childtrackingsystem-editchildobservationlist :idResult="selectedResult"></childtrackingsystem-editchildobservationlist>
        </div>
        <div v-if="isChildForm">
            <childtrackingsystem-observationform
                :idResult="selectedResult"
                :idChildForm="selectedChildForm"
            ></childtrackingsystem-observationform>
        </div>
        <div
            v-if="isLoading"
            class="modalLoader"
        >
            <img
                src="../../assets/img/loading.gif"
                alt="Loading"
                style="width: 80px; height: 80px;"
            >
        </div>

        <div
            class="modal fade"
            id="infoModal"
            tabindex="-1"
            aria-hidden="true"
        >
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-3">
                                <icon name="look-into"></icon>
                            </div>
                            <div class="col-9">Bekijk observatielijst</div>
                        </div>
                        <div class="row">
                            <div class="col-3">
                                <icon name="reminder"></icon>
                            </div>
                            <div class="col-9">Herinnering maken voor observatielijst</div>
                        </div>
                        <div class="row">
                            <div class="col-3">
                                <icon name="file-contract"></icon>
                            </div>
                            <div class="col-9">Maak observatieformulier aan</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import ChildtrackingsystemEditchildobservationlist from "./EditObservationList";
    import ChildtrackingsystemObservationform from "./ObservationForm";
    import icon from "@/components/Icon.vue";
    export default {
        name: 'ChildtrackingsystemResults',
        components: {icon, ChildtrackingsystemObservationform, ChildtrackingsystemEditchildobservationlist},
        data() {
            return {
                isLoading: false,
                isTrigger: false,
                isContent: false,
                results: [],
                triggerPeriod: false,
                triggerDate: null,
                triggerDescription: null,
                analysedChildren: [],
                listTitle: null,
                listNote: null,
                noteChecked: null,
                categories: [],
                answers: [],
                checkedAnswer: [],
                checkedList: false,
                checkedChild: this.$store.selectedChild,
                idResult: null,
                idChildForm: null,
                isAllResults: true,
                trajects: [],
                childrenCTS: [],
                lists: [],
                categoryNote: [],
                answerNote: [],
                childId: null,
                listId: null,
                categoryId: null,
                formId: null,
                isFormContent: false,
                showActive: true,
                isModalInfo: false,
              isAnalyse: false,
              isChildForm: false,
              selectedResult: 0,
              selectedChildForm: 0
            }
        },
        computed: {
            deviceToken() {
                return this.$store.getters.deviceToken
            },
            session() {
                return this.$store.getters.session
            }
        },
        created() {
            window.novict = {
                device: {
                    device_token: this.deviceToken
                },
                session: {
                    session_token: this.session.session_token
                }
            }
            this.getResults(true)
        },
        methods: {
            childSelect(event) {
                this.checkedChild = event.target.value
                this.childId = event.target.value
                this.searchResults()
                return event.target.value
            },
            listSelect(event) {
                this.checkedList = event.target.value
                this.listId = event.target.value
                this.searchResults()
                return event.target.value
            },
            getResults(active) {
                this.isLoading = true
                this.$store.commit('REGISTER_ACTIVE_REQUEST')
              // eslint-disable-next-line no-undef
                this.showActive = active
                this.$request.post('/ChildTrackingSystem/results', {
                    idEstablishment: this.$store.getters.selectedEstablishment.id,
                    idChild: this.childId,
                    idList: this.listId,
                    idGroup: this.$store.getters.selectedGroupsQueryString,
                    showActive: this.showActive
                }).then((response) => {
                    this.isLoading = false
                    this.$store.commit('REMOVE_ACTIVE_REQUEST')
                    if (response.results) {
                        this.results = response.results
                        this.childrenCTS = response.children
                        this.lists = response.lists
                        this.idResult = response.idResult
                        this.idChildForm = response.idChildForm
                        this.showActive = response.showActive
                    }
                })
            },
            searchResults() {
                this.isLoading = true
                this.$store.commit('REGISTER_ACTIVE_REQUEST')
              // eslint-disable-next-line no-undef
                this.$request.post('/ChildTrackingSystem/results', {
                  idEstablishment: this.$store.getters.selectedEstablishment.id,
                  idChild: this.childId,
                  idList: this.listId,
                  idGroup: this.$store.getters.selectedGroupsQueryString,
                  showActive: this.showActive
                }).then((response) => {
                  this.isLoading = false
                  this.$store.commit('REMOVE_ACTIVE_REQUEST')
                  if (response.results) {
                    this.results = response.results
                  }
                })
            },
            changeTrigger(event) {
                if (event.target.name === "triggerDate") {
                    this.triggerDate = event.target.value
                    this.triggerPeriod = false
                } else if (event.target.name === "triggerPeriod") {
                    this.triggerPeriod = event.target.value
                    this.triggerDate = null
                } else {
                    this.triggerDescription = event.target.value
                }
                return event.target.value
            },
            saveTrigger(idResult) {
                this.isLoading = true
                this.$store.commit('REGISTER_ACTIVE_REQUEST')
              // eslint-disable-next-line no-undef
                this.$request.post('/ChildTrackingSystem/triggers', {
                    triggerDate: this.triggerDate,
                    triggerPeriod: this.triggerPeriod,
                    triggerDescription: this.triggerDescription,
                    idResult: idResult,
                    idEstablishment: this.$store.getters.selectedEstablishment.id,
                    idGroup: this.$store.getters.selectedGroupsQueryString
                }).then((response) => {
                        this.isLoading = false
                        this.$store.commit('REMOVE_ACTIVE_REQUEST')
                        if (response) {
                            this.closeModal('saveasModal' + idResult)
                        }
                    })
            },
          changeResultStatus(idResult, status) {
            this.isLoading = true
            this.$store.commit('REGISTER_ACTIVE_REQUEST')
            // eslint-disable-next-line no-undef
            this.$request.post('/ChildTrackingSystem/changeResultStatus', {
              idResult: idResult,
              status: status
            }).then((response) => {
              this.isLoading = false
              this.$store.commit('REMOVE_ACTIVE_REQUEST')
              if (response) {
                this.getResults(response.showActive)
              }
            })
          },
            goBack() {
                this.getResults()
                this.isContent = false
            },
            openModal(id) {
                document.getElementById(id).style.display = ''
            },
            closeModal(id) {
              document.getElementById(id).style.display = 'none'
              if (id === 'modalInfo') {
                this.isModalInfo = false
              }
            },
            seeLegenda() {
              this.isModalInfo = true
            },
            openAnalyse(idResult) {
              this.isAnalyse = true
              this.selectedResult = idResult
            },
            openChildForm(idResult, idChildForm) {
              this.isChildForm = true
              this.selectedResult = idResult
              this.selectedChildForm = idChildForm
            }

        }
    }
</script>
<style scoped>

    .table {
        width: 100%;
    }

    .table th {
        color: #666;
        background-color: #f0f0f5;
        border-top: 1px solid #ddd !important;
    }

    .table td {
        border-bottom: 1px solid #ddd !important;
        color: #666;
    }

    .button {
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        background-color: #ffffff;
        box-sizing: border-box;
        padding-left: 16px;
        padding-right: 16px;
        height: 40px;
        border-radius: 4px;
        border-style: solid;
        border-width: 1px;
        border-color: #F87137;
        color: #F87137;
    }

    .button:hover {
        border-color: #DE4808;
        color: #DE4808;
    }

    .button:active {
        border-color: #DE4808;
        color: #DE4808;
    }

    .button:focus {
        border-color: #DE4808;
        color: #DE4808;
        border-width: 2px;
    }

    .input-date {
        color: #666;
        border: 1px solid #ddd !important;
    }

    .modalLoader {
        position: absolute;
        z-index: 1;
        left: 0;
        top: 100px;
        width: 100%;
        height: 100%;
        overflow: auto;
    }
</style>